(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SocialMediaDetailController', SocialMediaDetailController);

    SocialMediaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SocialMedia', 'Runner', 'Trainer'];

    function SocialMediaDetailController($scope, $rootScope, $stateParams, previousState, entity, SocialMedia, Runner, Trainer) {
        var vm = this;

        vm.socialMedia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:socialMediaUpdate', function(event, result) {
            vm.socialMedia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
